import { Grid } from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDInput from "components/Basics/MDInput";

const InputTextarea = ({ label, value, onChange, disabled, error }) => {
	return (
		<Grid size={{ md: 12 }}>
			<MDBox>
				<MDInput
					error={error}
					label={label}
					value={value ?? ""}
					onChange={e => {
						if (!disabled) onChange(e.target.value);
					}}
					multiline
					fullWidth
					minRows={1}
					maxRows={8}
					inputProps={{
						readOnly: disabled,
						style: {
							overflowY: "auto",
							resize: "none"
						}
					}}
					sx={
						disabled
							? {
									"& .MuiInputBase-root": {
										backgroundColor: "#f0f2f5",
										cursor: "default"
									},
									"& .MuiInputBase-input": {
										cursor: "default"
									}
								}
							: {}
					}
				/>
			</MDBox>
		</Grid>
	);
};

export default InputTextarea;
